class OaklenTestimonials extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;
    this.slides = Array.from(this.querySelectorAll('[data-oaklen-testimonials-slide]'));
    this.current = this.querySelector('[data-oaklen-testimonials-current]');
    this.previousButton = this.querySelector('[data-oaklen-testimonials-prev]');
    this.nextButton = this.querySelector('[data-oaklen-testimonials-next]');
    this.activeIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
    this.isAnimating = false;

    if (this.activeIndex < 0) {
      this.activeIndex = 0;
    }

    this.previousButton?.addEventListener('click', () => this.goTo(this.activeIndex - 1, -1));
    this.nextButton?.addEventListener('click', () => this.goTo(this.activeIndex + 1, 1));

    this.updateCounter();
    this.updateControls();
  }

  goTo(index, direction = 1) {
    if (!this.slides.length || this.slides.length <= 1 || this.isAnimating) return;

    const lastIndex = this.slides.length - 1;
    let nextIndex = index;

    if (index < 0) {
      nextIndex = lastIndex;
    } else if (index > lastIndex) {
      nextIndex = 0;
    }

    if (nextIndex === this.activeIndex) return;

    this.animateTo(nextIndex, direction);
  }

  animateTo(nextIndex, direction) {
    const currentSlide = this.slides[this.activeIndex];
    const nextSlide = this.slides[nextIndex];
    const enterClass = direction > 0 ? 'is-entering-from-right' : 'is-entering-from-left';
    const leaveClass = direction > 0 ? 'is-leaving-to-left' : 'is-leaving-to-right';

    this.isAnimating = true;
    this.clearAnimationClasses(currentSlide);
    this.clearAnimationClasses(nextSlide);

    currentSlide.classList.add('is-exiting');

    nextSlide.classList.add('is-active', enterClass);
    nextSlide.setAttribute('aria-hidden', 'false');

    nextSlide.offsetHeight;

    requestAnimationFrame(() => {
      currentSlide.classList.add(leaveClass);
      currentSlide.classList.remove('is-active');
      currentSlide.setAttribute('aria-hidden', 'true');
      nextSlide.classList.remove(enterClass);
    });

    const finish = () => {
      this.clearAnimationClasses(currentSlide);
      this.activeIndex = nextIndex;
      this.isAnimating = false;
      this.updateCounter();
      this.updateControls();
    };

    currentSlide.addEventListener('transitionend', finish, { once: true });
    window.setTimeout(() => {
      if (this.isAnimating) finish();
    }, 420);
  }

  clearAnimationClasses(slide) {
    slide.classList.remove(
      'is-exiting',
      'is-entering-from-right',
      'is-entering-from-left',
      'is-leaving-to-left',
      'is-leaving-to-right'
    );
  }

  updateCounter() {
    if (this.current) {
      this.current.textContent = String(this.activeIndex + 1).padStart(2, '0');
    }
  }

  updateControls() {
    const controlsDisabled = this.slides.length <= 1;
    this.previousButton?.toggleAttribute('disabled', controlsDisabled);
    this.nextButton?.toggleAttribute('disabled', controlsDisabled);
  }
}

if (!customElements.get('oaklen-testimonials')) {
  customElements.define('oaklen-testimonials', OaklenTestimonials);
}
